import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import CommonLawResults from "components/OrderDetail/Results/CommonLawResults/CommonLawResults";
import StateSearchResults from "components/OrderDetail/Results/StateSearchResults/StateSearchResults";
import FederalSearchResults from "components/OrderDetail/Results/FederalSearchResults/FederalSearchResults";
import Pagination from "components/Pagination/Pagination";

const Container = styled.div`
  min-width: 100%;
  max-width: 100%;
  padding: 25px 32px 56px;
  background: #ffffff;
  box-shadow: 0px 3px 25px rgba(168, 168, 168, 0.3);

  animation: 0.2s linear fadeIn;
  @keyframes fadeIn {
    from {
      opacity: 0%;
    }
    to {
      opacity: 100%;
    }
  }
`;
const EmptyMessage = styled.div`
  color: #7b848d;
  font-weight: bold;
  text-align: center;
`;

const Row = styled.div`
  display: flex;
  padding: 24px 8px 32px;
`;
const Label = styled.div`
  font-family: "Montserrat";
  font-weight: 700;
  font-size: 16px;
  line-height: 12px;
  color: #7b848d;
`;
const Data = styled(Label)`
  padding-left: 24px;
  font-family: "Montserrat";
  font-weight: 500;
`;

function MonitoringReportsDesktop({ monitoringReports }) {
  const [currentPage, setCurrentPage] = useState(1);

  if (!monitoringReports)
    return (
      <Container>
        <EmptyMessage>No Monitoring reports found</EmptyMessage>
      </Container>
    );

  const reportsArray = Object.keys(monitoringReports).filter((idx) => monitoringReports[idx].completed);

  const idx = reportsArray[currentPage - 1];

  return reportsArray.length ? (
    <>
      <Pagination top currentPage={currentPage} totalPages={reportsArray.length} onClick={setCurrentPage} />
      <Container>
        <Row>
          <Label>Date:</Label>
          <Data>{idx}</Data>
        </Row>
        <FederalSearchResults federalSearchResults={monitoringReports[idx].federalSearchResults} />
        <StateSearchResults stateSearchResults={monitoringReports[idx].stateSearchResults} />
        <CommonLawResults commonLawResults={monitoringReports[idx].commonLawResults} />
      </Container>
      <Pagination bottom currentPage={currentPage} totalPages={reportsArray.length} onClick={setCurrentPage} />
    </>
  ) : (
    <Container>
      <EmptyMessage>No Monitoring reports found</EmptyMessage>
    </Container>
  );
}

MonitoringReportsDesktop.propTypes = {
  monitoringReports: PropTypes.object,
};

export default MonitoringReportsDesktop;
